import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import Paging from '../interfaces/common/paging';
import Pagination from '../interfaces/common/pagination';
import { RootState } from '../setup';
import D365FeedbackStatus from '../interfaces/output/d365FeedbackStatus';

export type D365FeedbackStatusState = {
    d365FeedbackStatus: D365FeedbackStatus;
    isLoading: boolean;
    d365FeedbackStatuses: Pagination<D365FeedbackStatus>;
    error: HttpErrorResponse | undefined;
};

const initialState: D365FeedbackStatusState = {
    d365FeedbackStatus: {} as D365FeedbackStatus,
    d365FeedbackStatuses: { content: [] as Array<D365FeedbackStatus> } as Pagination<D365FeedbackStatus>,
    isLoading: false,
    error: undefined
};

export const d365FeedbackStatusSlice = createSlice({
    name: 'd365FeedbackStatus',

    initialState,
    reducers: {
        fetchD365FeedbackStatuses: (state: D365FeedbackStatusState, _action: PayloadAction<{paging: Paging}>) => {
            state.isLoading = true;
        },
        fetchD365FeedbackStatusesSuccess: (state: D365FeedbackStatusState, action: PayloadAction<Pagination<D365FeedbackStatus>>) => {
            state.isLoading = false;
            state.d365FeedbackStatuses = action.payload;
        },
        fetchD365FeedbackStatusesError: (state: D365FeedbackStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchD365FeedbackStatusById: (state: D365FeedbackStatusState, _action: PayloadAction<string>) => {
            state.isLoading = true;
        },
        fetchD365FeedbackStatusByIdSuccess: (state: D365FeedbackStatusState, action: PayloadAction<D365FeedbackStatus>) => {
            state.isLoading = false;
            state.d365FeedbackStatus = action.payload;
        },
        fetchD365FeedbackStatusByIdError: (state: D365FeedbackStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const { fetchD365FeedbackStatusById, fetchD365FeedbackStatusByIdError, fetchD365FeedbackStatusByIdSuccess,
    fetchD365FeedbackStatuses, fetchD365FeedbackStatusesError, fetchD365FeedbackStatusesSuccess } = d365FeedbackStatusSlice.actions;

export const isLoadingD365FeedbackStatus = (state: RootState): boolean => state.d365FeedbackStatusReducer.isLoading;
export const getD365FeedbackStatuses = (state: RootState): Pagination<D365FeedbackStatus> => state.d365FeedbackStatusReducer.d365FeedbackStatuses;
export const getD365FeedbackStatus = (state: RootState): D365FeedbackStatus => state.d365FeedbackStatusReducer.d365FeedbackStatus;

export default d365FeedbackStatusSlice.reducer;